
import Toolbar from "../../components/animation/Toolbar";
import Viewer from "../../components/animation/Viewer";
import { useLoadSvg } from "../../common/useLoadSvg";
import './index.css'

const Animation = () => {
    document.title = '动态展示 - 元纹';

    const { loading, loadedSvgList, loadDataList } = useLoadSvg();
    if (loading) {
        return <div>Loading...</div>;
    }
    return (
        <div id='page'>
            <Toolbar svgList={loadedSvgList} loadDataList={loadDataList} />
            {!!loadedSvgList.length && <Viewer svgList={loadedSvgList} />}
        </div>
    );
};

export default Animation;